import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 20px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Data = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  gap: 15px;
`;

export const Value = styled.div`
  font-weight: bold;
`;

export const ClickableText = styled(Value)`
  text-decoration: underline;
`;

export const UncoloredLink = styled(Link)`
  color: unset;
`;
